import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface AddressPickerProps {
  className?: string;
  address?: string;
  city?: string;
  onClick?: () => void;
}

export default function AddressPicker ({
  className,
  address = '',
  city = '',
  onClick
}: AddressPickerProps) {
  const { t } = useTranslation('common')

  return (
    <div
      className={cn(styles.addressPicker, className)}
      onClick={onClick}
    >
      <div className={styles.addressPicker__content}>
        <div className={styles.addressPicker__line}>
          {t('delivery')} в г. {city}
        </div>
        <div className={styles.addressPicker__line}>
          {address}
        </div>
      </div>
      <ReactSVG
        src="/icons/arrow-right.svg"
        wrapper="span"
        className={styles.addressPicker__arrow}
      />
    </div>
  )
}
